<div *ngIf="rule.recurringType === 1">
  <header>
    <div class="icn-radio-button">
      <input checked="checked" type="radio" name="radiogroup2" id="f" />
      <label for="f"
        >Time Based (The graphics will be played in intervals)</label
      ><br />
    </div>
  </header>
  <main>
    <div class="input-group">
      <p>
        <label>PLAY MEDIA EVERY DAY </label>
      </p>
      <p>
        <label>FROM: </label>
        <evrideo-time-editor
          [(valueMs)]="rule.timeBasedTimeStartMs"
          [fontSize]="'18px'"
          [height]="'21px'"
          [minMs]="0"
          [fullMode]="true"
          [frameRate]="channel.framerate"
          [type]="channelTimeCodeFormat"
        ></evrideo-time-editor>
        <label> TO: </label>
        <evrideo-time-editor
          [(valueMs)]="rule.timeBasedTimeEndMs"
          [fontSize]="'18px'"
          [height]="'21px'"
          [minMs]="rule.timeBasedTimeStartMs"
          [fullMode]="true"
          [frameRate]="channel.framerate"
          [type]="channelTimeCodeFormat"
        ></evrideo-time-editor>
      </p>
      <p>
        <label> EVERY: </label>
        <icn-number-input
          [min]="0"
          [step]="1"
          [useDefaultHtmlInput]="true"
          [(value)]="rule.timeBasedIntervalMins"
          (valueChange)="validateTimeBasedIntervalMins($event)"
        ></icn-number-input>
        &nbsp;<span class="label-title-special">mins</span>
      </p>
      <p>
        <label>DURATION: </label>
        <evrideo-time-editor
          [(valueMs)]="rule.timeBasedGraphicDurationMs"
          [fontSize]="'18px'"
          [height]="'21px'"
          [minMs]="0"
          [maxMs]="(rule.timeBasedIntervalMins * 60000)"
          [fullMode]="true"
          [frameRate]="channel.framerate"
          [type]="channelTimeCodeFormat"
        ></evrideo-time-editor>
      </p>
    </div>
  </main>
</div>
<div *ngIf="rule.recurringType === 2">
  <header>
    <div class="icn-radio-button">
      <input checked="checked" type="radio" name="radiogroup2" id="g" />
      <label for="g"
        >Video Based (The media will be added to selected videos)</label
      ><br />
    </div>
  </header>
  <main>
    <ol class="tasks">
      <li class="task">
        <header>Select videos to display media on:</header>
        <div class="task-content">
          <div class="icn-radio-button">
            <input
              type="radio"
              id="o1"
              name="radiogroup3"
              [value]="1"
              [ngModel]="rule.videoBasedDisplayOn"
              (ngModelChange)="changeVideoBasedDisplayOn($event)"
            />
            <label for="o1">All Videos</label>

            <input
              type="radio"
              id="o2"
              name="radiogroup3"
              [value]="2"
              [ngModel]="rule.videoBasedDisplayOn"
              (ngModelChange)="changeVideoBasedDisplayOn($event)"
            />
            <label [ngStyle]="{'padding-left': '30px'}" for="o2"
              >Selected Videos</label
            >
          </div>

          <div class="input-group" *ngIf="rule.videoBasedDisplayOn === 2">
            <label>SELECT VIDEO TAGS:</label>
            <icn-dropdown
              #videoTagsDropdown
              [allowMultiple]="true"
              [selectedValues]="rule.videoBasedFilterTags"
              (itemClicked)="onVideoBasedFilterTagsItemClicked($event)"
            >
              <icn-dropdown-item
                [title]="'All Tags'"
                [value]="null"
              ></icn-dropdown-item>
              <icn-dropdown-item
                *ngFor="let tag of tags"
                [title]="tag"
                [value]="tag"
              ></icn-dropdown-item>
            </icn-dropdown>
            <div class="input-group select-condition-ig">
              <input
                type="checkbox"
                [(ngModel)]="showVideoBasedConditionForTags"
              />
              <label>SELECT CONDITION FOR TAGS</label>

              <icn-dropdown
                [hidden]="!showVideoBasedConditionForTags"
                [short]="true"
                [(selectedValue)]="rule.videoBasedFilterCondition"
              >
                <icn-dropdown-item
                  [title]="'Or'"
                  [value]="1"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'And'"
                  [value]="2"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Not'"
                  [value]="3"
                ></icn-dropdown-item>
              </icn-dropdown>
              <div class="note" [hidden]="!showNote">
                <span style="color: #7d8fa1">This rule applies to: </span
                ><span [innerHTML]="noteToDisplay"></span>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="task">
        <header>Now set when graphics will appear on videos:</header>
        <div class="task-content">
          <div class="input-group">
            <div class="icn-radio-button">
              <input
                type="radio"
                id="videoBasedFitToWholeVideo"
                name="graphicAppearanceGroup"
                [checked]="rule.videoBasedFitToWholeVideo"
                (change)="setVideoBasedFitToWholeVideo(true)"
              />
              <label for="videoBasedFitToWholeVideo"
                >Extend the duration of the media to fit the duration of the
                video</label
              ><br />

              <input
                type="radio"
                id="timing"
                name="graphicAppearanceGroup"
                [checked]="!rule.videoBasedFitToWholeVideo"
                (change)="setVideoBasedFitToWholeVideo(false)"
              />
              <label for="timing">Timing:</label><br />
            </div>
            <div *ngIf="!rule.videoBasedFitToWholeVideo">
              <input
                type="number"
                min="0"
                [(ngModel)]="rule.videoBasedTimingInterval"
              />
              <icn-dropdown
                [short]="true"
                [(selectedValue)]="rule.videoBasedTimingMinSec"
                [ngStyle]="{'width': '100px'}"
              >
                <icn-dropdown-item
                  [title]="'Min'"
                  [value]="1"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Sec'"
                  [value]="0"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Milliseconds'"
                  [value]="2"
                ></icn-dropdown-item>
              </icn-dropdown>
              <icn-dropdown
                class="video-based-timing-dropdown"
                [(selectedValue)]="rule.videoBasedTiming"
              >
                <icn-dropdown-item
                  [title]="'After video starts'"
                  [value]="1"
                ></icn-dropdown-item>
                <icn-dropdown-item
                  [title]="'Before video ends'"
                  [value]="2"
                ></icn-dropdown-item>
              </icn-dropdown>
              <p>
                <input
                  type="checkbox"
                  class="override-media-duration-checkbox"
                  [checked]="rule.videoBasedTimingVideoDurationMs !== null"
                  (change)="onOverrideMediaDurationClick($event)"
                />
                <label>Override Media Duration:</label>
                <evrideo-time-editor
                  *ngIf="rule.videoBasedTimingVideoDurationMs !== null"
                  [(valueMs)]="rule.videoBasedTimingVideoDurationMs"
                  [fontSize]="'15px'"
                  [height]="'20px'"
                  [minMs]="0"
                  [fullMode]="true"
                  [frameRate]="channel.framerate"
                  [type]="channelTimeCodeFormat"
                ></evrideo-time-editor>
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="task">
        <header>If the video is segmented show the media on:</header>
        <div class="task-content">
          <div class="input-group">
            <icn-dropdown
              [autoHeight]="true"
              [(selectedValue)]="rule.segmentationBehaviour"
            >
              <icn-dropdown-item
                [title]="'Every Segment'"
                [value]="0"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'First Segment'"
                [value]="1"
              ></icn-dropdown-item>
              <icn-dropdown-item
                [title]="'Last Segment'"
                [value]="2"
              ></icn-dropdown-item>
            </icn-dropdown>
          </div>
        </div>
      </li>
    </ol>
  </main>
</div>
<div *ngIf="rule.recurringType === 3">
  <header>
    <div class="icn-radio-button">
      <input checked="checked" type="radio" name="radiogroup2" id="h" />
      <label for="h">Always show (The graphics will be always visible)</label
      ><br />
    </div>
  </header>
  <main>
    <div class="input-group">
      <label>SHOW DURING</label>

      <div class="icn-radio-button">
        <input
          type="radio"
          id="i"
          name="radiogroup4"
          [value]="1"
          [(ngModel)]="rule.alwaysBasedDuring"
        />
        <label for="i">All</label><br />

        <input
          type="radio"
          id="j"
          name="radiogroup4"
          [value]="2"
          [(ngModel)]="rule.alwaysBasedDuring"
        />
        <label for="j">Commercials</label><br />

        <input
          type="radio"
          id="k"
          name="radiogroup4"
          [value]="3"
          [(ngModel)]="rule.alwaysBasedDuring"
        />
        <label for="k">Videos</label><br />
      </div>
    </div>
  </main>
</div>
